import { render, staticRenderFns } from "./Tool.vue?vue&type=template&id=4b7fe746&scoped=true"
import script from "./Tool.vue?vue&type=script&lang=ts"
export * from "./Tool.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Tool.vue?vue&type=style&index=0&id=4b7fe746&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4b7fe746",
  "6220dd92"
  
)

export default component.exports